import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppointmentTypeSurveyTemplateService {
  private apiUrl = 'api';

  constructor(private http: HttpClient) { }

  // Get survey templates linked to an appointment type
  getSurveyTemplatesForAppointmentType(appointmentTypeId: string): Observable<any> {
    const token = localStorage.getItem('token');
    return this.http.get(`${this.apiUrl}/appointment-types/${appointmentTypeId}/survey-templates`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }

  // Get appointment types linked to a survey template
  getAppointmentTypesForSurveyTemplate(surveyTemplateId: string): Observable<any> {
    const token = localStorage.getItem('token');
    return this.http.get(`${this.apiUrl}/survey-templates/${surveyTemplateId}/appointment-types`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }

  // Link a survey template to an appointment type
  linkSurveyTemplateToAppointmentType(appointmentTypeId: string, surveyTemplateId: string, isDefault: boolean = false): Observable<any> {
    const token = localStorage.getItem('token');
    return this.http.post(`${this.apiUrl}/appointment-types/survey-templates/link`, {
      appointmentTypeId,
      surveyTemplateId,
      isDefault
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }

  // Unlink a survey template from an appointment type
  unlinkSurveyTemplateFromAppointmentType(appointmentTypeId: string, surveyTemplateId: string): Observable<any> {
    const token = localStorage.getItem('token');
    return this.http.delete(`${this.apiUrl}/appointment-types/${appointmentTypeId}/survey-templates/${surveyTemplateId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }

  // Set a survey template as default for an appointment type
  setDefaultSurveyTemplate(appointmentTypeId: string, surveyTemplateId: string): Observable<any> {
    const token = localStorage.getItem('token');
    return this.http.post(`${this.apiUrl}/appointment-types/survey-templates/set-default`, {
      appointmentTypeId,
      surveyTemplateId
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }
} 